import { vnModule } from '../../vendor/valnet/valnet_jslib/vnApp/vnModule';
import { vnAppZone } from '../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone';
import { login } from './login';
import { menu_mod } from './menu';
import { menu_sidebar } from './menu_sidebar';
import { header } from './header';
import { users_edit } from './users_edit';
import { users_list } from './users_list';
import { reset_password } from './reset_password';
import { users_profile } from './users_profile';
import { logs } from "./logs";
import { tasks } from './tasks';
import { tasks_edit } from '../../vendor/valnet/valnet_jslib/vnApp/tasks_edit';
import { roles } from "./roles";
import { roles_edit } from "../../vendor/valnet/valnet_jslib/vnApp/roles_edit";
import { roles_view } from "../../vendor/valnet/valnet_jslib/vnApp/roles_view";
import { home } from './home';
import { revenueInsights } from './revenueInsights';
import { auctionInsights } from './auctionInsights';
import { auctionDeliveryHealth } from './auctionDeliveryHealth';
import { auctionResultDistribution } from './auctionResultDistribution';
import { menu_page } from './menu_page';
import { mortgage_export } from './mortgage_export';
import { admin_leads } from './recruiting/admin_leads';
import { admin_question_banks } from './recruiting/admin_question_banks';
import { admin_question_bank_edit } from './recruiting/admin_question_bank_edit';
import { admin_recruiting_questions } from './recruiting/admin_recruiting_questions';
import { admin_recruiting_question_edit } from './recruiting/admin_recruiting_question_edit';
import { admin_lead_question_edit } from './recruiting/admin_lead_question_edit';
import { admin_partners } from './recruiting/admin_partners';
import { admin_partner_edit } from './recruiting/admin_partner_edit';
import { admin_creatives } from './recruiting/admin_creatives';
import { admin_creative_edit } from './recruiting/admin_creative_edit';
import { admin_tracking_contracts } from './recruiting/admin_tracking_contracts';
import { admin_tracking_contract_edit } from './recruiting/admin_tracking_contract_edit';
import { admin_transmissions } from './recruiting/admin_transmissions';
import { admin_transmission_edit } from './recruiting/admin_transmission_edit';
import { admin_transmission_groups } from './recruiting/admin_transmission_groups';
import { admin_transmission_group_edit } from './recruiting/admin_transmission_group_edit';
export class pageFactory {
    get_actionHandler(typeName, vnAppZone) {
        let obj;
        console.log(`Instantiating module [${typeName}]`);
        switch (typeName) {
            case 'home':
                obj = new home(vnAppZone);
                break;
            case 'users':
                obj = new users_list(vnAppZone);
                break;
            case 'users_edit':
                obj = new users_edit(vnAppZone);
                break;
            case 'users_profile':
                obj = new users_profile(vnAppZone);
                break;
            case 'login':
                obj = new login(vnAppZone);
                break;
            case 'menu':
                obj = new menu_mod(vnAppZone);
                break;
            case 'menu_sidebar':
                obj = new menu_sidebar(vnAppZone);
                break;
            case 'header':
                obj = new header(vnAppZone);
                break;
            case 'reset_password':
                obj = new reset_password(vnAppZone);
                break;
            case 'logs':
                obj = new logs(vnAppZone);
                break;
            case "tasks":
                obj = new tasks(vnAppZone);
                break;
            case "tasks_edit":
                obj = new tasks_edit(vnAppZone);
                break;
            case "roles":
                obj = new roles(vnAppZone);
                break;
            case "roles_edit":
                obj = new roles_edit(vnAppZone);
                break;
            case "roles_view":
                obj = new roles_view(vnAppZone);
                break;
            case "revenue_insights":
                obj = new revenueInsights(vnAppZone);
                break;
            case "auction_insights":
                obj = new auctionInsights(vnAppZone);
                break;
            case "auction_delivery_health":
                obj = new auctionDeliveryHealth(vnAppZone);
                break;
            case "auction_result_distribution":
                obj = new auctionResultDistribution(vnAppZone);
                break;
            case "menu_page":
                obj = new menu_page(vnAppZone);
                break;
            case "mortgage_export":
                obj = new mortgage_export(vnAppZone);
                break;
            case "admin_leads":
                obj = new admin_leads(vnAppZone);
                break;
            case "question_banks":
            case "admin_question_banks":
                obj = new admin_question_banks(vnAppZone);
                break;
            case "admin_question_bank_edit":
                obj = new admin_question_bank_edit(vnAppZone);
                break;
            case "admin_recruiting_questions":
                obj = new admin_recruiting_questions(vnAppZone);
                break;
            case "admin_recruiting_question_edit":
                obj = new admin_recruiting_question_edit(vnAppZone);
                break;
            case "partners":
                obj = new admin_partners(vnAppZone);
                break;
            case "admin_lead_question_edit":
                obj = new admin_lead_question_edit(vnAppZone);
                break;
            case "admin_partners":
                obj = new admin_partners(vnAppZone);
                break;
            case "admin_partner_edit":
                obj = new admin_partner_edit(vnAppZone);
                break;
            case "creatives":
            case "admin_creatives":
                obj = new admin_creatives(vnAppZone);
                break;
            case "admin_creative_edit":
                obj = new admin_creative_edit(vnAppZone);
                break;
            case "contracts":
            case "admin_tracking_contracts":
                obj = new admin_tracking_contracts(vnAppZone);
                break;
            case "admin_tracking_contract_edit":
                obj = new admin_tracking_contract_edit(vnAppZone);
                break;
            case "transmissions":
            case "admin_transmissions":
                obj = new admin_transmissions(vnAppZone);
                break;
            case "admin_transmission_edit":
                obj = new admin_transmission_edit(vnAppZone);
                break;
            case "admin_transmission_groups":
                obj = new admin_transmission_groups(vnAppZone);
                break;
            case "admin_transmission_group_edit":
                obj = new admin_transmission_group_edit(vnAppZone);
                break;
        }
        return obj;
    }
}
